// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"milk"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16.85 4.8V2H12H7.15V4.8L5 9.7V22H19V9.7L16.85 4.8Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.05 22H19V9.7L16.85 4.8V2H7.15V4.8L5 9.7V22H15.05ZM15.05 22V9.7L16.625 5.4125M5.5 9.7H14.55M7.65 4.8H16.35","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 18V14H8.001L10 16L11.99 14H12V18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MilkIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'milk',
    ref,
    icon: element,
  },
));

MilkIcon.displayName = 'MilkIcon';

export default MilkIcon;
